import React from "react";
import { Img, ResponsiveImgDecorator } from "../Img";
export const ToggleableTitleContentSwiperCard = ({ imageUrl, imageAlt, responsiveImageData }) => (React.createElement("div", { className: "toggleable-title-content-swiper-card-root" },
    React.createElement("div", { className: "toggleable-title-content-swiper-card-root__imageContainer" },
        React.createElement(ResponsivelyDecoratedImg, { src: imageUrl, alt: imageAlt, helperProps: responsiveImageData }))));
const ResponsivelyDecoratedImg = ResponsiveImgDecorator(Img);
